// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"cff7393b","183":"a530172a","348":"f5bd6410","430":"6c5856db","591":"2cd3df97","742":"66a89862","930":"7976f26d"}[chunkId] + ".chunk.css";
};